import { render } from "./TextPlaceholder.vue?vue&type=template&id=337a04eb&scoped=true&ts=true&lang=pug"
import script from "./TextPlaceholder.vue?vue&type=script&lang=ts"
export * from "./TextPlaceholder.vue?vue&type=script&lang=ts"

import "./TextPlaceholder.vue?vue&type=style&index=0&id=337a04eb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337a04eb"]])

export default __exports__